var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNotAllowed(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 32,
    fill: "none",
    viewBox: "0 0 32 32",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#a)"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#b)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "c",
    width: 18,
    height: 18,
    x: 9,
    y: 11,
    fill: "#000",
    maskUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M9 11h18v18H9z"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M21.477 24.89a6 6 0 0 1-8.367-8.367l8.367 8.368Zm1.414-1.413a6 6 0 0 0-8.367-8.367l8.367 8.367ZM18 28a8 8 0 1 0 0-16 8 8 0 0 0 0 16Z",
    clipRule: "evenodd"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#E14D2C",
    fillRule: "evenodd",
    d: "M21.477 24.89a6 6 0 0 1-8.367-8.367l8.367 8.368Zm1.414-1.413a6 6 0 0 0-8.367-8.367l8.367 8.367ZM18 28a8 8 0 1 0 0-16 8 8 0 0 0 0 16Z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#EEE",
    d: "m13.11 16.523.353-.353-.418-.418-.343.481.407.29Zm1.414-1.414-.29-.407-.482.343.418.418.354-.354Zm6.662 9.374A5.473 5.473 0 0 1 18 25.5v1a6.473 6.473 0 0 0 3.767-1.202l-.58-.814ZM18 25.5a5.5 5.5 0 0 1-5.5-5.5h-1a6.5 6.5 0 0 0 6.5 6.5v-1ZM12.5 20c0-1.189.376-2.288 1.017-3.186l-.815-.58A6.473 6.473 0 0 0 11.5 20h1Zm.256-3.123 8.367 8.367.707-.707-8.367-8.367-.707.707Zm10.542 6.89A6.473 6.473 0 0 0 24.5 20h-1a5.473 5.473 0 0 1-1.017 3.186l.815.58ZM24.5 20a6.5 6.5 0 0 0-6.5-6.5v1a5.5 5.5 0 0 1 5.5 5.5h1ZM18 13.5a6.473 6.473 0 0 0-3.767 1.202l.58.815A5.473 5.473 0 0 1 18 14.5v-1Zm-3.83 1.963 8.367 8.367.707-.707-8.367-8.367-.707.707ZM18 28.5a8.5 8.5 0 0 0 8.5-8.5h-1a7.5 7.5 0 0 1-7.5 7.5v1Zm8.5-8.5a8.5 8.5 0 0 0-8.5-8.5v1a7.5 7.5 0 0 1 7.5 7.5h1ZM18 11.5A8.5 8.5 0 0 0 9.5 20h1a7.5 7.5 0 0 1 7.5-7.5v-1ZM9.5 20a8.5 8.5 0 0 0 8.5 8.5v-1a7.5 7.5 0 0 1-7.5-7.5h-1Z",
    mask: "url(#c)"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#d)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#2E2B32",
    d: "m7.394 14.856-2.95-10.35a.5.5 0 0 1 .7-.583l9.775 4.676a.496.496 0 0 1-.048.917l-4.123 1.461a.5.5 0 0 0-.267.222l-2.168 3.77a.504.504 0 0 1-.92-.113Z"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#EEE",
    strokeWidth: 0.5,
    d: "m4.202 4.573 2.95 10.35c.182.638 1.049.744 1.38.17l2.168-3.77a.25.25 0 0 1 .133-.111l4.123-1.461a.744.744 0 0 0 .072-1.376L5.253 3.7c-.585-.28-1.228.255-1.051.874Z"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "b",
    width: 23,
    height: 23,
    x: 6.5,
    y: 10,
    colorInterpolationFilters: "sRGB",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    result: "hardAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1.5
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0.0705882 0 0 0 0 0.0745098 0 0 0 0 0.101961 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_96360_46125"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in: "SourceGraphic",
    in2: "effect1_dropShadow_96360_46125",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "d",
    width: 17.781,
    height: 18.344,
    x: 0.922,
    y: 1.873,
    colorInterpolationFilters: "sRGB",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    result: "hardAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1.5
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0.0705882 0 0 0 0 0.0745098 0 0 0 0 0.101961 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_96360_46125"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in: "SourceGraphic",
    in2: "effect1_dropShadow_96360_46125",
    result: "shape"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h32v32H0z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNotAllowed);
export default __webpack_public_path__ + "static/media/NotAllowed.c4e0aa8f2a70eb0648898e2ef3cb2ddc.svg";
export { ForwardRef as ReactComponent };